import type { SxProps } from '@mui/material'
import { ListItemText as MUIListItemText } from '@mui/material'
import React from 'react'
interface IListItemTextProps {
  primary: string
  sx?: SxProps
}
export default function ListItemText({ primary, sx }: IListItemTextProps) {
  return <MUIListItemText primary={primary} sx={sx} />
}
